import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MoreHeader from './MoreHeader';
import MoreSidebar from './MoreSidebar';
import MoreContent from './MoreContent';
import { DEFAULT_MORE_SECTION, getVisibleMoreSections } from './moreSections';

const MoreWorkspace = ({
  section,
  onSectionChange,
  onClose,
  projectId,
  version,
  conversationId,
}) => {
  const [showDetail, setShowDetail] = useState(false);
  const sections = getVisibleMoreSections();
  const visibleIds = sections.map((item) => item.id);
  const activeSection = visibleIds.indexOf(section) !== -1 ? section : visibleIds[0] || DEFAULT_MORE_SECTION;

  useEffect(() => {
    if (activeSection !== section) onSectionChange(activeSection);
  }, [activeSection, section, onSectionChange]);

  const selectSection = (id) => {
    onSectionChange(id);
    setShowDetail(true);
  };

  return (
    <section className="vibe-more" aria-label="More">
      <MoreHeader onClose={onClose} />
      <div className={`vibe-more-body${showDetail ? ' is-detail' : ''}`}>
        <MoreSidebar sections={sections} activeSection={activeSection} onSelect={selectSection} />
        <MoreContent
          section={activeSection}
          projectId={projectId}
          version={version}
          conversationId={conversationId}
          showBack={showDetail}
          onBack={() => setShowDetail(false)}
        />
      </div>
    </section>
  );
};

MoreWorkspace.propTypes = {
  section: PropTypes.string.isRequired,
  onSectionChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  projectId: PropTypes.string,
  version: PropTypes.string,
  conversationId: PropTypes.string,
};

MoreWorkspace.defaultProps = {
  projectId: '',
  version: '',
  conversationId: '',
};

export default MoreWorkspace;
